import * as client_hooks from '../../../src/hooks.client.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141')
];

export const server_loads = [];

export const dictionary = {
		"/": [11],
		"/about": [12],
		"/accept_invitation/[token]": [13],
		"/app/activity": [14,[2]],
		"/app/experimental/admin/letter": [15,[2]],
		"/crm/professionals/[id]/edit": [16],
		"/email": [17],
		"/email/magic_link_invite": [18],
		"/email/week_in_review": [19],
		"/invitation/accept/[token]": [20],
		"/invitation/existing/[token]": [21],
		"/login": [22],
		"/login/forgot": [23],
		"/login/reset/[token]": [24],
		"/mfa": [25],
		"/onboarding/email": [26,[3]],
		"/onboarding/name": [27,[3]],
		"/onboarding/pms": [28,[3]],
		"/onboarding/team": [29,[3]],
		"/onboarding/template": [30,[3]],
		"/policy": [31],
		"/preview/[link]": [~32,[4]],
		"/register": [33],
		"/share/[key]": [34],
		"/transclick/forgot": [35],
		"/transclick/login": [36],
		"/transclick/register": [37],
		"/transclick/reset/[token]": [38],
		"/v4/app/admin": [39,[5,6]],
		"/v4/app/admin/add_debit_subscription": [40,[5,6]],
		"/v4/app/admin/analyse/letters": [41,[5,6]],
		"/v4/app/admin/background_tasks": [42,[5,6]],
		"/v4/app/admin/background_tasks/transcription": [43,[5,6]],
		"/v4/app/admin/blog": [44,[5,6]],
		"/v4/app/admin/calendar_view": [45,[5,6]],
		"/v4/app/admin/change_organisation": [46,[5,6]],
		"/v4/app/admin/code-quality": [47,[5,6,7]],
		"/v4/app/admin/compare/[id]": [48,[5,6]],
		"/v4/app/admin/crm/activity": [51,[5,6,8]],
		"/v4/app/admin/crm/analytics": [52,[5,6,8]],
		"/v4/app/admin/crm/batch-email": [53,[5,6,8]],
		"/v4/app/admin/crm/campaigns": [54,[5,6,8]],
		"/v4/app/admin/crm/campaigns/create": [61,[5,6,8]],
		"/v4/app/admin/crm/campaigns/[id]": [55,[5,6,8,9]],
		"/v4/app/admin/crm/campaigns/[id]/pending-actions": [56,[5,6,8,9]],
		"/v4/app/admin/crm/campaigns/[id]/segments": [57,[5,6,8,9]],
		"/v4/app/admin/crm/campaigns/[id]/segments/create": [58,[5,6,8,9]],
		"/v4/app/admin/crm/campaigns/[id]/stats": [59,[5,6,8,9]],
		"/v4/app/admin/crm/campaigns/[id]/steps": [60,[5,6,8,9]],
		"/v4/app/admin/crm/dashboard": [62,[5,6,8]],
		"/v4/app/admin/crm/duplicates/[mode]/[name]": [63,[5,6,8]],
		"/v4/app/admin/crm/email-accounts": [64,[5,6,8]],
		"/v4/app/admin/crm/email-management": [65,[5,6,8]],
		"/v4/app/admin/crm/email-monitoring": [66,[5,6,8]],
		"/v4/app/admin/crm/email-templates": [67,[5,6,8]],
		"/v4/app/admin/crm/gmail-watch": [68,[5,6,8]],
		"/v4/app/admin/crm/ingest": [69,[5,6,8]],
		"/v4/app/admin/crm/list": [70,[5,6,8]],
		"/v4/app/admin/crm/other-pages": [71,[5,6,8]],
		"/v4/app/admin/crm/pending-actions/[id]": [72,[5,6,8]],
		"/v4/app/admin/crm/pending-approvals": [73,[5,6,8]],
		"/v4/app/admin/crm/sales-memory": [74,[5,6,8]],
		"/v4/app/admin/crm/sales-notes": [75,[5,6,8]],
		"/v4/app/admin/crm/system-health": [76,[5,6,8]],
		"/v4/app/admin/crm/tasks": [77,[5,6,8]],
		"/v4/app/admin/crm/tests": [79,[5,6,8]],
		"/v4/app/admin/crm/test": [78,[5,6,8]],
		"/v4/app/admin/crm/tokens": [80,[5,6,8]],
		"/v4/app/admin/crm/[id]": [49,[5,6,8]],
		"/v4/app/admin/crm/[id]/edit": [50,[5,6,8]],
		"/v4/app/admin/email-monitoring": [81,[5,6]],
		"/v4/app/admin/global_letter_templates": [82,[5,6]],
		"/v4/app/admin/limit_testing": [83,[5,6]],
		"/v4/app/admin/manage_teams": [84,[5,6]],
		"/v4/app/admin/modal": [85,[5,6]],
		"/v4/app/admin/ota": [86,[5,6]],
		"/v4/app/admin/run_tests": [87,[5,6]],
		"/v4/app/admin/statistics": [88,[5,6]],
		"/v4/app/admin/statistics/daily": [89,[5,6]],
		"/v4/app/admin/statistics/edits": [90,[5,6]],
		"/v4/app/admin/statistics/overview": [91,[5,6]],
		"/v4/app/admin/statistics/snippets": [92,[5,6]],
		"/v4/app/admin/telegram": [93,[5,6]],
		"/v4/app/documents/dashboard": [94,[5]],
		"/v4/app/documents/dashboard/inbox": [95,[5]],
		"/v4/app/home": [96,[5]],
		"/v4/app/recording": [97,[5]],
		"/v4/app/report/dashboard": [98,[5]],
		"/v4/app/report/dashboard/inbox": [99,[5]],
		"/v4/app/report/review/[id]": [100,[5]],
		"/v4/app/report/upload": [101,[5]],
		"/v4/app/review/[id]": [102,[5]],
		"/v4/app/settings": [103,[5,10]],
		"/v4/app/settings/AI_instructions": [104,[5,10]],
		"/v4/app/settings/account": [105,[5,10]],
		"/v4/app/settings/appearance": [106,[5,10]],
		"/v4/app/settings/billing": [107,[5,10]],
		"/v4/app/settings/calibration": [108,[5,10]],
		"/v4/app/settings/configure_upload_title": [109,[5,10]],
		"/v4/app/settings/contacts": [110,[5,10]],
		"/v4/app/settings/custom_status": [111,[5,10]],
		"/v4/app/settings/email_templates": [112,[5,10]],
		"/v4/app/settings/email_templates/create": [113,[5,10]],
		"/v4/app/settings/integrations": [114,[5,10]],
		"/v4/app/settings/integrations/email": [115,[5,10]],
		"/v4/app/settings/integrations/email/callback/[provider]": [116,[5,10]],
		"/v4/app/settings/integrations/pms": [117,[5,10]],
		"/v4/app/settings/integrations/pms/callback/salesforce": [118,[5,10]],
		"/v4/app/settings/letter_templates": [119,[5,10]],
		"/v4/app/settings/macro": [120,[5,10]],
		"/v4/app/settings/plans": [121,[5,10]],
		"/v4/app/settings/plans/[slug]": [~122,[5,10]],
		"/v4/app/settings/preferences": [123,[5,10]],
		"/v4/app/settings/profile": [124,[5,10]],
		"/v4/app/settings/report/status": [125,[5,10]],
		"/v4/app/settings/report/wizard": [126,[5,10]],
		"/v4/app/settings/signature": [127,[5,10]],
		"/v4/app/settings/systems": [128,[5,10]],
		"/v4/app/settings/team": [129,[5,10]],
		"/v4/app/settings/transclick": [130,[5,10]],
		"/v4/app/settings/transclick/memory": [131,[5,10]],
		"/v4/app/settings/transclick/snippets": [132,[5,10]],
		"/v4/app/settings/usage": [133,[5,10]],
		"/v4/app/settings/word_templates": [134,[5,10]],
		"/v4/app/transclick": [135,[5]],
		"/v4/app/transclick/docs": [136,[5]],
		"/v4/app/transclick/download": [137,[5]],
		"/v4/app/transclick/memory": [138,[5]],
		"/v4/app/transclick/snippets": [139,[5]],
		"/v4/app/upload": [140,[5]],
		"/v4/command": [141,[5]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';